// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.store/css-loader-virtual-4b0343164a/package/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay__nFL23Zz8oxyuq_mozmYD {
  background: rgb(var(--cp-blackRgb) / 0.1);
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--cp-zIndexDialog);
}

.focusOn__BXNS7dRaDhvQM7YSrtrE {
  /* ignore the FocusOn root for layout purposes */
  display: contents;
}

@keyframes fade-in__RgoXtDCvXp_zLUEhFX0G {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.commands__VZxKM817eSqGY6etKAYx {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
  padding: 0 20px 8px;
}

/* actual dialog root element */
.dialog__ZWJzr7wpZVh1FbHdy6Q2 {
  /* used for the top border and title color */
  --cp-dialogAccent: var(--cp-themePrimary);
  animation: fade-in__RgoXtDCvXp_zLUEhFX0G 0.1s ease-in-out;
  width: 80vw;
  align-self: stretch;
  margin: 20px 0;
  background: var(--cp-white);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-top: 4px solid var(--cp-dialogAccent);
  border-radius: 3px;
  box-shadow:
    rgb(var(--cp-blackRgb) / 22%) 0px 25.6px 57.6px 0px,
    rgb(var(--cp-blackRgb) / 18%) 0px 4.8px 14.4px 0px;
  position: relative;
  outline: transparent solid 3px;
}
.dialog__ZWJzr7wpZVh1FbHdy6Q2.error__sqI0jdiToNIQgfQ6E95R {
  --cp-dialogAccent: var(--cp-errorDark);
}

.draggable__J68SmatPFr3O_E5JYUtt {
  cursor: move;
}

.titleArea__Bq9plXsgb2IJ0KMqM0yK {
  display: flex;
  align-items: center;
  padding: 12px 12px 2px 20px;
}

.title__LTsU7kHigVvD2yo102t7 {
  margin: 0;
  padding: 0;
  flex-grow: 1;
  font-size: var(--cp-fontSizeTitle);
  font-weight: 600;
  color: var(--cp-dialogAccent);
}
.title__LTsU7kHigVvD2yo102t7:focus-visible {
  /* This receives focus on open--remove the outline since it's not interactive */
  outline: none;
}

.content__iIhQSIaymuRzCftzQT8Y {
  flex-grow: 1;
  overflow: auto;
  border-top: 1px solid var(--cp-border);
  box-sizing: border-box;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dialog/Dialog.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAyC;EACzC,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;AACnB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,yDAAmC;EACnC,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,4CAA4C;EAC5C,kBAAkB;EAClB;;sDAEoD;EACpD,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,+EAA+E;EAC/E,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sCAAsC;EACtC,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV","sourcesContent":[".overlay {\n  background: rgb(var(--cp-blackRgb) / 0.1);\n  border: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: var(--cp-zIndexDialog);\n}\n\n.focusOn {\n  /* ignore the FocusOn root for layout purposes */\n  display: contents;\n}\n\n@keyframes fade-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.commands {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-shrink: 0;\n  padding: 0 20px 8px;\n}\n\n/* actual dialog root element */\n.dialog {\n  /* used for the top border and title color */\n  --cp-dialogAccent: var(--cp-themePrimary);\n  animation: fade-in 0.1s ease-in-out;\n  width: 80vw;\n  align-self: stretch;\n  margin: 20px 0;\n  background: var(--cp-white);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  border-top: 4px solid var(--cp-dialogAccent);\n  border-radius: 3px;\n  box-shadow:\n    rgb(var(--cp-blackRgb) / 22%) 0px 25.6px 57.6px 0px,\n    rgb(var(--cp-blackRgb) / 18%) 0px 4.8px 14.4px 0px;\n  position: relative;\n  outline: transparent solid 3px;\n}\n.dialog.error {\n  --cp-dialogAccent: var(--cp-errorDark);\n}\n\n.draggable {\n  cursor: move;\n}\n\n.titleArea {\n  display: flex;\n  align-items: center;\n  padding: 12px 12px 2px 20px;\n}\n\n.title {\n  margin: 0;\n  padding: 0;\n  flex-grow: 1;\n  font-size: var(--cp-fontSizeTitle);\n  font-weight: 600;\n  color: var(--cp-dialogAccent);\n}\n.title:focus-visible {\n  /* This receives focus on open--remove the outline since it's not interactive */\n  outline: none;\n}\n\n.content {\n  flex-grow: 1;\n  overflow: auto;\n  border-top: 1px solid var(--cp-border);\n  box-sizing: border-box;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay__nFL23Zz8oxyuq_mozmYD`,
	"focusOn": `focusOn__BXNS7dRaDhvQM7YSrtrE`,
	"commands": `commands__VZxKM817eSqGY6etKAYx`,
	"dialog": `dialog__ZWJzr7wpZVh1FbHdy6Q2`,
	"fade-in": `fade-in__RgoXtDCvXp_zLUEhFX0G`,
	"error": `error__sqI0jdiToNIQgfQ6E95R`,
	"draggable": `draggable__J68SmatPFr3O_E5JYUtt`,
	"titleArea": `titleArea__Bq9plXsgb2IJ0KMqM0yK`,
	"title": `title__LTsU7kHigVvD2yo102t7`,
	"content": `content__iIhQSIaymuRzCftzQT8Y`
};
export default ___CSS_LOADER_EXPORT___;
